import React, { useState, useEffect } from 'react'
import WidgetLayout from 'layouts/widget'
import CalComponent from 'components/calwidget'
import { useRouter } from 'next/router'
import LoadingIndicator from 'shared/LoadingIndicator'
import ComingSoon from 'components/calwidget/coming-soon'

export default function CRWidget() {
  const router = useRouter()
  const { slug } = router.query
  const { [slug]: CalWidgetComponent } = CalComponent
  const [loaded, setloaded] = useState(false)

  useEffect(() => {
    setloaded(true)
  }, [])

  if (!loaded) {
    return <LoadingIndicator />
  }

  return (
    <WidgetLayout>
      {CalWidgetComponent ? <CalWidgetComponent /> : <ComingSoon />}
    </WidgetLayout>
  )
}
